import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const MinisterDetails = () => {
  // Piche wale page se bheja gaya data yahan receive kar rahe hain
  const location = useLocation();
  const { ministerData } = location.state || {}; 

  // Agar direct link khula aur data nahi mila, toh wapis jane ka option dein
  if (!ministerData) {
    return (
      <div className="container mt-5 text-center">
        <h3>Data not found</h3>
        <Link to="/government" className="btn btn-primary mt-3">Go Back</Link>
      </div>
    );
  }

  return (
    <div className="container mt-5 mb-5">
        <Link to="/government" className="btn btn-outline-secondary mb-4">
          <i className="fa fa-arrow-left me-2"></i> Back to Cabinet
        </Link>
        
        <div className="row align-items-center">
            {/* Wahi Image */}
            <div className="col-lg-5 mb-4 mb-lg-0">
                <img 
                  src={ministerData.image} 
                  alt={ministerData.name} 
                  className="img-fluid rounded shadow"
                  style={{ width: '100%', objectFit: 'cover' }}
                />
            </div>

            {/* Wahi Description */}
            <div className="col-lg-7">
                <h6 className="text-uppercase text-muted fw-bold mb-2">{ministerData.title}</h6>
                <h1 className="display-5 fw-bold mb-3" style={{color: '#003366', fontFamily: 'serif'}}>
                  {ministerData.name}
                </h1>
                <h4 className="text-secondary mb-4" style={{fontWeight: '300'}}>
                  {ministerData.roleEnglish}
                </h4>
                
                <div className="card bg-light border-0 p-4">
                    <h5 className="mb-3 border-bottom pb-2">Biography Highlights</h5>
                    <ul className="list-unstyled">
                        {ministerData.descriptionItems.map((item, index) => (
                            <li key={index} className="mb-3 d-flex">
                                <i className="fa fa-check-circle text-primary me-3 mt-1"></i>
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    </div>
  );
};

export default MinisterDetails;